import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { GabaritService } from '../gabarit/gabarit.service';

@Injectable({
  providedIn: 'root',
})
export class GestionTitreService {
  constructor(
    private readonly titleService: Title,
    private readonly translateService: TranslateService,
    private readonly gabaritService: GabaritService
  ) {}

  addTitreOnglet(dcr: string) {
    if (this.gabaritService.isAppMobile() && dcr.includes('titreOnglet')) {
      dcr = dcr.replace('titreOnglet', 'titreOngletMobile');
    }
    this.translateService.get(dcr).subscribe((texte: string) => this.titleService.setTitle(texte));
  }
}
